import { validator } from "@/utils/validator";

export const masterDataBusinessClassificationSchema = validator.object().shape({
  businessClassificationNumber: validator.string().trim().emptyToNull().label("区分番号").required(),
  businessCategory: validator.string().trim().emptyToNull().label("取扱業務等の区分 ").required(),
  informationDisplay: validator.string().trim().emptyToNull().label("留意事項・主な職業例").notRequired(),
});
